import React, { useEffect, useRef, useState } from 'react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Badge,
  Box,
  Button,
  Flex,
  FormControl,
  HStack,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  SimpleGrid,
  Stack,
  Text,
  useDisclosure,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import LogoutHeader from '../../components/LogoutHeader'
import useBrand from '../../hooks/useBrand'
import useVolume from '../../hooks/useVolume'
import useMaterial from '../../hooks/useMaterial'
import useBattlefield from '../../hooks/useBattlefield'
import useProduct from '../../hooks/useProduct'
import clientAxios from '../../config/axios'
import { Toaster, toast } from 'react-hot-toast'
import LoadingComponents from '../../components/LoadingComponents'
import ProductImage from '../../components/ProductImage'
const quilmesImages = require.context('../../assets/images', true)

const ProductManagement = () => {
  const [backgroundBlackYes, setBackgroundBlackYes] = useState(false)
  const [backgroundBlackNo, setBackgroundBlackNo] = useState(false)
  const [brands] = useBrand()
  const [volumes] = useVolume()
  const [materials] = useMaterial()
  const [battlefields] = useBattlefield()
  const [productsApi, setProducts] = useState([])
  const { productsBackend, loadingProducts } = useProduct()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [openCreate, setOpenCreate] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [productId, setProductId] = useState('')
  const [success, setSuccess] = useState('')
  const [successId, setSuccessId] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [size, setSize] = useState('full')
  const cancelRef = useRef()
  const initialRef = React.useRef(null)
  const finalRef = React.useRef(null)
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const navigate = useNavigate()
  const [selectedBrandId, setSelectedBrandId] = useState('')
  const [selectedVolumeId, setSelectedVolumeId] = useState('')
  const [selectedMaterialId, setSelectedMaterialId] = useState('')
  const [selectedBattlefieldId, setSelectedBattlefieldId] = useState('')
  const [selectedReturnabilityId, setSelectedReturnabilityId] = useState('')
  const [selectedBrand, setSelectedBrand] = useState('')
  const [selectedVolume, setSelectedVolume] = useState('')
  const [selectedMaterial, setSelectedMaterial] = useState('')
  const [selectedBattlefield, setSelectedBattlefield] = useState('')
  const [selectedReturnability, setSelectedReturnability] = useState('')
  const [duplicateProduct, setDuplicateProduct] = useState('')
  const [isDuplicateProduct, setIsDuplicateProduct] = useState(false)
  const productitos = productsApi.filter((product) => {
    return product
  })
  useEffect(() => {
    battlefields.push({
      battlefieldId: null,
      description: "Battlefield",
      modificationDate: null
    })
  },[battlefields])
  useEffect(() => {
    if (loadingProducts) {
      return
    }

    setProducts(productsBackend)
  }, [loadingProducts])

  const handleSelectBrand = (e) => {
    const {name, value} = e.target
    sessionStorage.setItem("brandId", value)
    setSelectedBrandId(value)
  }
  const handleSelectVolume = (e) => {
    const {name, value} = e.target
    sessionStorage.setItem("volumeId", value)
    setSelectedVolumeId(value)
  }
  const handleSelectMaterial = (e) => {
    const {name, value} = e.target
    sessionStorage.setItem("materialId", value)
    setSelectedMaterialId(value)
  }
  const handleSelectBattlefield = (e) => {
    const {name, value} = e.target
    sessionStorage.setItem("battlefieldId", value)
    setSelectedBattlefieldId(value)
  }

  const handleClickYes = (e) => {
    setBackgroundBlackNo(false)
    setBackgroundBlackYes(true)
    sessionStorage.setItem("returnabilityId", 1)
    setSelectedReturnabilityId(1)
  }

  const handleClickNo = (e) => {
    setBackgroundBlackYes(false)
    setBackgroundBlackNo(true)
    sessionStorage.setItem("returnabilityId", 2)
    setSelectedReturnabilityId(2)
  }

  useEffect(() => {
    if (productitos.length === 0) {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }, [productitos])

  if (loading) {
    return <LoadingComponents loading={loading} />
  }

  const onCloseCreate = () => {
    setOpenCreate(false)
  }

  const onCloseEdit = () => {
    setOpenEdit(false)
  }

  const handleSubmitCreate = (e) => {
    e.preventDefault()

    if (selectedBrandId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedVolumeId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedMaterialId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedReturnabilityId === '') {
      setError('El campo no puede estar vacío.')

      return
    }

    if (error === '') {
      const idBrand = parseInt(sessionStorage.getItem("brandId"))
      const idVolume = parseInt(sessionStorage.getItem("volumeId"))
      const idMaterial = parseInt(sessionStorage.getItem("materialId"))
      let idBattlefield = parseInt(sessionStorage.getItem("battlefieldId"))
      const idReturnability = parseInt(sessionStorage.getItem("returnabilityId"))
      if( idBattlefield === -1 || idBattlefield === "" || idBattlefield === 'Battlefield') {
        idBattlefield = null
      }else {
        idBattlefield = parseInt(idBattlefield)
      }
      clientAxios
        .post('/product', {
          brandId: idBrand,
          materialId: idMaterial,
          volumeId: idVolume,
          returnabilityId: idReturnability,
          battlefieldId: idBattlefield,
        })
        .then((res) => {
          console.log(res.data)
          setSuccess('¡Listo! Se creó el producto')
          setSuccessId(productId)
          onCloseCreate()

          setTimeout(() => {
            navigate(0)
          }, 1000)
        })
        .catch((err) => {
          if (err.response.data.message === 'PRODUCT_EXISTS') {
            setDuplicateProduct('Ya existe un producto con estas características.')
            setIsDuplicateProduct(true)
            return
          }
          console.log(err)
          onCloseCreate()
        })
    }

    setTimeout(() => {
      setIsDuplicateProduct(false)
      setSuccess('')
      setSuccessId('')
    }, 1000)
  }

  const handleSubmitEdit = (e) => {
    e.preventDefault()

    if (selectedBrandId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedVolumeId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedMaterialId === '') {
      setError('El campo no puede estar vacío.')

      return
    }
    if (selectedReturnabilityId === '') {
      setError('El campo no puede estar vacío.')

      return
    }

    if (error === '') {
        const idBrand = parseInt(sessionStorage.getItem("brandId"))
        const idVolume = parseInt(sessionStorage.getItem("volumeId"))
        const idMaterial = parseInt(sessionStorage.getItem("materialId"))
        let idBattlefield = parseInt(sessionStorage.getItem("battlefieldId"))
        const idReturnability = parseInt(sessionStorage.getItem("returnabilityId"))
        if( idBattlefield === -1 || idBattlefield === "Battlefield" || idBattlefield === "") {
          idBattlefield = null
        }else {
          idBattlefield = parseInt(idBattlefield)
        }
        clientAxios
          .put(`/product/${productId}`, {
            brandId: idBrand,
            materialId: idMaterial,
            volumeId: idVolume,
            returnabilityId: idReturnability,
            battlefieldId: idBattlefield,
          })
        .then((res) => {
          setSuccess('¡Listo! Se actualizó el producto')
          setSuccessId(productId)
          onCloseEdit()

          setTimeout(() => {
            navigate(0)
          }, 1000)
        })
        .catch((err) => {
            if (err.response.data.message === 'PRODUCT_EXISTS') {
              setDuplicateProduct('Ya existe un producto con estas características.')
              setIsDuplicateProduct(true)

            return
          }
          onCloseEdit()
        })
    }

    setTimeout(() => {
      setIsDuplicateProduct(false)
      setSuccess('')
      setSuccessId('')
    }, 1000)
  }

  const deleteElement = () => {
    clientAxios
      .delete(`/product/${productId}`)
      .then((res) => {
        setSuccess('¡Listo! Se eliminó el producto')
        setSuccessId(productId)
        onClose()
        setTimeout(() => {
          navigate(0)
        }, 1000)
      })
      .catch(() => {
        onClose()
      })

    setTimeout(() => {
      setSuccess('')
      setSuccessId('')
      setIsDuplicateProduct(false)
    }, 1000)
  }


  return (
    <Stack paddingBottom={'2rem'}>
      <Box
        {...(isLargerThan768
          ? { display: 'flex', justifyContent: 'space-between' }
          : { display: 'none' })}
        alignItems={'center'}
        className='logo-home'
        paddingLeft={'5%'}
        paddingRight={'5%'}
      >
        <LogoutHeader />
      </Box>
      <Stack borderBottom={' 1px solid #E1E1E1'}>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}
          margin={'0 auto'}
          padding={{ base: '1rem 1rem', md: '1rem 5rem' }}
          width={{ base: '90%', md: '100%' }}
        >
          <Link to={'/home'}>
            <ArrowBackIcon color={'#0A0808'} h={6} w={6} />
          </Link>
          <Text fontWeight={'bold'} paddingLeft={{ base: '0rem', md: '7rem' }}>
            Gestión de Productos
          </Text>
          <Button
            {...(!isLargerThan768
              ? { visibility: 'hidden' }
              : { visibility: 'visible' })}
            marginTop={'0rem'}
            variant={'btn-quilmes'}
            w={'15%'}
            onClick={() => {setOpenCreate(true)
              setBackgroundBlackNo(false)
              setBackgroundBlackYes(false)
              sessionStorage.setItem("battlefieldId", -1)
              }}
          >
            Agregar producto
          </Button>
        </Box>
      </Stack>

      <Stack
        background={'#F7F7F7'}
        marginTop={'0rem !important'}
        w={{ base: '100%', md: '100%' }}
      >
        <Box
          className='container-bar'
          display={'flex'}
          flexDirection={'column'}
          flexWrap={'wrap'}
          h='auto'
          justifyContent={'space-around'}
          overflow='auto'
          padding='2rem 1rem'
          w={{ base: '100%', md: '90%' }}
        >
          {productitos.length !== 0 ? (
            <VStack mx={'auto'}>
              <SimpleGrid
                columns={[2, 3, 4, 5]}
                paddingTop={'1rem'}
                spacing='20px'
                height={'fit-content'}
              >
              {
              productitos
                  .sort((a, b) =>
                  a.brand === null || b.brand === null? -1 : (
                  a.brand.description.toLowerCase() <
                  b.brand.description.toLowerCase()
                      ? -1
                      : 1 )
                  )
                  .map((item) => (
                    <FormControl
                      key={item.id}
                      background={'#FFF'}
                      borderRadius={'10px'}
                      display={'flex'}
                      flexDirection={'row'}
                      flexWrap={'wrap'}
                      height={'fit-content'}
                      justifyContent={'space-between'}
                      marginTop={'0.5rem'}
                      w={'85%'}
                    >
                      <Stack
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'space-between'}
                        width={'100%'}
                      >
                        <Box w={'100%'}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                          >
                            <Text
                              fontSize='sm'
                              fontWeight='bold'
                              height={'42px'}
                              marginLeft={2}
                              marginTop={3}
                              width={'70%'}
                            >
                              {item.brand !== null? item.brand.description : "Marca"}
                            </Text>
                            <ProductImage item={item} />
                          </Box>
                          <Text marginLeft={2} marginTop={0}>
                            {item.volume !== null? item.volume.description : null}
                          </Text>
                          <Stack marginLeft={2} marginTop={2}>
                            <Badge
                              bg={'#E1E1E1'}
                              borderRadius={'10px'}
                              color={'#3B3939'}
                              fontSize={'10px'}
                              fontWeight={'400'}
                              padding={'.1rem .8rem'}
                              w={'max-content'}
                              {...(item.material !== null
                                ? { display: 'block' }
                                : { display: 'none' })}
                            >
                              {item.material !== null ? item.material.description : null}
                            </Badge>
                            <Badge
                              bg={'#E1E1E1'}
                              borderRadius={'10px'}
                              color={'#3B3939'}
                              fontSize={'10px'}
                              fontWeight={'400'}
                              padding={'.1rem .8rem'}
                              w={'max-content'}
                              {...(item.returnability !== null
                                ? { display: 'block' }
                                : { display: 'none' })}
                            >
                              {item.returnability !== null ? item.returnability.description : null}
                            </Badge>
                          </Stack>
                          <Box
                            paddingBottom={1}
                            paddingLeft={2}
                            paddingRight={2}
                            paddingTop={6}
                            //  width={'100%'}
                          >
                            <Text
                              fontSize={'10px'}
                              fontWeight={'400'}
                              marginBottom={'15px'}
                              color={'#707070'}
                            >
                              {item.battlefield !== null
                                ? item.battlefield.description
                                : null}
                            </Text>
                            </Box>
                            <Box
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'center'}
                gap={{ base: '0.5rem', md: '1rem' }}
                paddingBottom={'1rem'}
                marginRight={{ base: '1.5rem', md: '1rem' }}
              >
                <Image
                  className='img-gestion'
                  cursor={'pointer'}
                  src={quilmesImages('./editar.svg')}
                  w={'40px'}
                  onClick={() => {
                    setProductId(item.id)
                    setOpenEdit(true)
                    if(item.brand !== null) {
                      sessionStorage.setItem("brandId", item.brand.brandId)
                      setSelectedBrandId(item.brand.brandId)
                      setSelectedBrand(item.brand.description)
                    } else {
                      setSelectedBrand("Marca *")
                    }
                    if(item.volume !== null) {
                      sessionStorage.setItem("volumeId", item.volume.volumeId)
                      setSelectedVolumeId(item.volume.volumeId)
                      setSelectedVolume(item.volume.description)
                    } else {
                      setSelectedVolume("Volumen *")
                    }
                    if(item.battlefield !== null) {
                      sessionStorage.setItem("battlefieldId", item.battlefield.battlefieldId)
                      setSelectedBattlefieldId(item.battlefield.battlefieldId)
                      setSelectedBattlefield(item.battlefield.description)
                    } else {
                      setSelectedBattlefield("Battlefield")
                      sessionStorage.setItem("battlefieldId", null)
                    }
                    if(item.material !== null) {
                      sessionStorage.setItem("materialId", item.material.materialId)
                      setSelectedMaterialId(item.material.materialId)
                      setSelectedMaterial(item.material.description)
                    } else {
                      setSelectedMaterial("Material *")
                    }
                    if(item.returnability !== null) {
                      sessionStorage.setItem("returnabilityId", item.returnability.returnabilityId)
                      setSelectedReturnabilityId(item.returnability.returnabilityId)
                      setSelectedReturnability(item.returnability.description)
                      if(item.returnability.returnabilityId === 1) {
                          setBackgroundBlackYes(true)
                          setBackgroundBlackNo(false)
                      } else if(item.returnability.returnabilityId === 2 ) {
                        setBackgroundBlackNo(true)
                        setBackgroundBlackYes(false)
                      }
                    }
                    else {
                        //son botones no deberia cambiar nada en el else
                    }
                  }}
                />
                <Image
                  className='img-gestion'
                  cursor={'pointer'}
                  src={quilmesImages('./Eliminar.svg')}
                  w={'40px'}
                  // obtener el id del producto
                  onClick={() => {
                    setProductId(item.id)
                    onOpen()
                  }}
                />
              </Box>
              <Badge
                    bg={'#FBE9BC'}
                    borderRadius={'10px'}
                    color={'#3B3939'}
                    fontSize={'10px'}
                    fontWeight={'400'}
                    padding={'.1rem .8rem'}
                    textAlign={'center'}
                    w={'100%'}
                    {...(item.brand == null || item.material == null || item.volume == null || item.returnability == null
                      ? { display: 'block' }
                      : { display: 'none' })}
                  >
                    {item.brand == null || item.material == null || item.volume == null || item.returnability == null ? "INCOMPLETO" : null}
                  </Badge>
                        </Box>
                      </Stack>

                    </FormControl>
                  ))}
{!isLargerThan768 ? (
          !openEdit && !openCreate ? (
            <Stack
              alignItems={'center'}
              bg={'#F7F7F7'}
              bottom={0}
              justifyContent={'center'}
              paddingBottom={'.5rem'}
              paddingTop='1rem'
              position={'fixed'}
              w={'100%'}
            >
              <Button
                margin={0}
                marginBottom={'1rem'}
                type='submit'
                variant='btn-quilmes'
                w={'90%'}
                onClick={() => {setOpenCreate(true)
                setBackgroundBlackNo(false)
                setBackgroundBlackYes(false)
                sessionStorage.setItem("battlefieldId", -1)
                }}
              >
                Agregar producto
              </Button>
            </Stack>
          ) : null
        ) : null}
              </SimpleGrid>
              </VStack>
          ) : null }
        </Box>
        </Stack>
{/* Modal de agregar */}
<Modal
        isCentered
        closeOnOverlayClick={false}
        finalFocusRef={finalRef}
        initialFocusRef={initialRef}
        isOpen={openCreate}
        width={{ base: '100%', md: '100%' }}
        onClose={onCloseCreate}
      >
        <ModalOverlay />
        <ModalContent marginRight={{ base: '0rem', md: '3rem' }}>
          <VStack
            alignItems={'flex-start'}
            as={'form'}
            display={'flex'}
            justifyContent={'flex-start'}
            onSubmit={handleSubmitCreate}
          >
            <ModalHeader fontSize={'16px'} fontWeight={'700'}>
              Agregar producto
            </ModalHeader>
            <ModalBody width={'100%'}>
              <FormControl
                className='floating-label-group'
                marginTop={'-.5rem'}
                paddingBottom={4}
                onFocus={() => {setError('')
              setDuplicateProduct('')
              }}
              >
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='brand'
                    marginTop={'1rem'}
                    onChange={handleSelectBrand}
                  >
                    <option className='option-select' value=''>
                      Marca *
                    </option>
                    {brands
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.brandId}
                          value={item.brandId}
                          //selected={item.description}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>

                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    paddingTop={'1rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                {/* Lista de volumenes, esto se puede agregar desde aca */}
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='volume'
                    marginTop={'1rem'}
                    onChange={handleSelectVolume}
                  >
                    <option className='option-select' value=''>
                      Volumen *
                    </option>
                    {volumes
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.volumeId}
                          value={item.volumeId}
                          //selected={item.description}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                {/* Lista de materiales, esto se puede agregar desde aca */}
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='material'
                    marginTop={'1rem'}
                    onChange={handleSelectMaterial}
                  >
                    <option className='option-select' value=''>
                      Material *
                    </option>
                    {materials
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.materialId}
                          value={item.materialId}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                <Text>
                  ¿Es retornable?
                </Text>
                <HStack
                width={'100%'}>
                  <Button
                  variant={'outline'}
                  colorScheme={'black'}
                  width={'45%'}
                  {...(backgroundBlackYes === true
                    ? { bg: 'black', color: 'white'}
                    : { bg: 'transparent', color: 'black'})}
                  onClick={handleClickYes}
                  >
                    Si
                  </Button>
                  <Button
                  id='noButton'
                  variant={'outline'}
                  colorScheme={'black'}
                  width={'45%'}
                  {...(backgroundBlackNo === true
                    ? { bg: 'black', color: 'white'}
                    : { bg: 'transparent', color: 'black'})}
                  onClick={handleClickNo}
                  >
                    No
                  </Button>
                </HStack>
                 {/* Lista de battlefields, esto se puede agregar desde aca */}
                 <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='battlefield'
                    marginTop={'1rem'}
                    onChange={handleSelectBattlefield}
                  >
                    <option className='option-select' value=''>
                      Battlefield
                    </option>
                    {battlefields
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.battlefieldId}
                          value={item.battlefieldId}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}

              </FormControl>
                {isDuplicateProduct && (
                  <Text
                  color={'#fff'}
                  background={'#3B3939'}
                  padding={'.5rem'}
                  >
                    {duplicateProduct}
                  </Text>
                )}

            </ModalBody>
            <ModalFooter
              alignItems={'center'}
              display={'flex'}
              flexDirection={'row'}
              gap={'1rem'}
              justifyContent={'space-between'}
              width={'100%'}
            >
              <Button
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginTop={'-1rem'}
                width={'100%'}
                onClick={onCloseCreate}
              >
                Cancelar
              </Button>
              <Button
                marginTop={'-1rem'}
                ml={3}
                type='submit'
                variant={'btn-quilmes'}
                width={'100%'}
              >
                Agregar
              </Button>
            </ModalFooter>
          </VStack>
        </ModalContent>
      </Modal>
{/* Modal de editar */}
<Modal
        isCentered
        closeOnOverlayClick={false}
        finalFocusRef={finalRef}
        initialFocusRef={initialRef}
        isOpen={openEdit}
        width={{ base: '100%', md: '100%' }}
        onClose={onCloseEdit}
      >
        <ModalOverlay />
        <ModalContent marginRight={{ base: '0rem', md: '3rem' }}>
          <VStack
            alignItems={'flex-start'}
            as={'form'}
            display={'flex'}
            justifyContent={'flex-start'}
            onSubmit={handleSubmitEdit}
          >
            <ModalHeader fontSize={'16px'} fontWeight={'700'}>
              Editar producto
            </ModalHeader>
            <ModalBody width={'100%'}>
            <FormControl
                className='floating-label-group'
                marginTop={'-.5rem'}
                paddingBottom={4}
                onFocus={() => {setError('')
                setDuplicateProduct('')
                }}
              >
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='brand'
                    marginTop={'1rem'}
                    onChange={handleSelectBrand}
                  >
                    <option className='option-select' value=''>
                    {selectedBrandId !== null
                        ? selectedBrand
                        : 'Marca *'}
                    </option>
                    {brands
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.brandId}
                          value={item.brandId}
                          //selected={item.description}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>

                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    paddingTop={'1rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                {/* Lista de embotelladores, esto se puede agregar desde aca */}
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='volume'
                    marginTop={'1rem'}
                    onChange={handleSelectVolume}
                  >
                    <option className='option-select' value=''>
                    {selectedVolumeId !== null
                        ? selectedVolume
                        : 'Volumen *'}
                    </option>
                    {volumes
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.volumeId}
                          value={item.volumeId}
                          //selected={item.description}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                {/* Lista de materiales, esto se puede agregar desde aca */}
                <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='material'
                    marginTop={'1rem'}
                    onChange={handleSelectMaterial}
                  >
                    <option className='option-select' value=''>
                      {selectedMaterialId !== null
                        ? selectedMaterial
                        : 'Material *'}
                    </option>
                    {materials
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.materialId}
                          value={item.materialId}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
                <Text>
                  ¿Es retornable?
                </Text>
                <HStack
                width={'80%'}>
                  <Button
                  id='yesButton'
                  variant={'outline'}
                  colorScheme={'black'}
                  width={'45%'}
                  {...(backgroundBlackYes === true
                    ? { bg: 'black', color: 'white'}
                    : { bg: 'transparent', color: 'black'})}
                  onClick={handleClickYes}
                  >
                    Si
                  </Button>
                  <Button
                  id='noButton'
                  variant={'outline'}
                  colorScheme={'black'}
                  width={'45%'}
                  {...(backgroundBlackNo === true
                    ? { bg: 'black', color: 'white'}
                    : { bg: 'transparent', color: 'black'})}
                    onClick={handleClickNo}>
                    No
                  </Button>
                </HStack>
                 {/* Lista de battlefields, esto se puede agregar desde aca */}
                 <div className='floating-label'>
                  <Select
                    className='floating-select'
                    name='battlefield'
                    marginTop={'1rem'}
                    onChange={handleSelectBattlefield}
                  >
                    <option className='option-select' value=''>
                    {selectedBattlefieldId !== null
                        ? selectedBattlefield
                        : 'Battlefield'}
                    </option>
                    {battlefields
                      .sort((a, b) =>
                        a.description.toLowerCase() <
                        b.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <option
                          key={item.battlefieldId}
                          value={item.battlefieldId}
                          w='20px'
                        >
                          {item.description}
                        </option>
                      ))}
                  </Select>
                </div>
                {error && (
                  <Text
                    color='red.500'
                    fontSize={'12px'}
                    paddingLeft={'.5rem'}
                    w={{ base: '75%', md: '100%' }}
                  >
                    {error}
                  </Text>
                )}
              </FormControl>
              {isDuplicateProduct && (
                  <Text
                  color={'#fff'}
                  background={'#3B3939'}
                  padding={'.5rem'}
                  >
                    {duplicateProduct}
                  </Text>
                )}
            </ModalBody>
            <ModalFooter
              alignItems={'center'}
              display={'flex'}
              flexDirection={'row'}
              gap={'1rem'}
              justifyContent={'space-between'}
              width={'100%'}
            >
              <Button
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginTop={'-1rem'}
                width={'100%'}
                onClick={onCloseEdit}
              >
                Cancelar
              </Button>
              <Button
                marginTop={'-1rem'}
                ml={3}
                type='submit'
                variant={'btn-quilmes'}
                width={'100%'}
              >
                Guardar
              </Button>
            </ModalFooter>
          </VStack>
        </ModalContent>
      </Modal>
{/* Modal de eliminación */}
{isLargerThan768 ? (
        <AlertDialog
          isCentered
          closeOnOverlayClick={false}
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                Eliminar producto
              </AlertDialogHeader>

              <AlertDialogBody
                fontSize={'14px'}
                fontStyle={'normal'}
                fontWeight={'400'}
                lineHeight={'22px'}
              >
                Se eliminará este producto definitivamente.
              </AlertDialogBody>

              <AlertDialogFooter
                alignItems={'flex-start !important'}
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'flex-start !important'}
              >
                <Button
                  ref={cancelRef}
                  _active={{ bg: '#FFF' }}
                  _focus={{ boxShadow: 'none' }}
                  _hover={{ bg: '#FFF' }}
                  bg={'#FFF'}
                  border={'1px solid #DB580B'}
                  color={'#DB580B'}
                  width={'100%'}
                  onClick={onClose}
                >
                  Cancelar
                </Button>
                <Button
                  marginTop={'0rem'}
                  ml={3}
                  variant={'btn-quilmes'}
                  width={'100%'}
                  onClick={() => deleteElement()}
                >
                  Eliminar
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      ) : (
        <Modal isOpen={isOpen} size={size} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader marginTop={'1rem'}>Eliminar producto</ModalHeader>
            <ModalBody>
              <Text marginTop={'-.5rem'}>
                Se eliminará este producto definitivamente.
              </Text>
            </ModalBody>
            <ModalFooter>
              <Button
                ref={cancelRef}
                _active={{ bg: '#FFF' }}
                _focus={{ boxShadow: 'none' }}
                _hover={{ bg: '#FFF' }}
                bg={'#FFF'}
                border={'1px solid #DB580B'}
                color={'#DB580B'}
                marginBottom={'1rem'}
                width={'100%'}
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                marginBottom={'1rem'}
                marginTop={'0rem'}
                ml={3}
                variant={'btn-quilmes'}
                width={'100%'}
                onClick={() => deleteElement()}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {success &&
        toast(
          () => (
            <Flex>
              <Text>{success}</Text>
            </Flex>
          ),
          { id: 'successId' }
        )}
      <Toaster
        position={'bottom-center'}
        toastOptions={{
          duration: 2000,
          style: {
            color: '#FFFFFF',
            backgroundColor: '#3B3939',
          },
        }}
      />


    </Stack>
  )
}

export default ProductManagement
